import { Identifier } from "../../id";
export class ProductCategoryId extends Identifier {
    constructor(id) {
        super("ProductCategoryId", id);
    }
}
